import React, { useEffect, useRef } from "react";

import * as d3 from "d3";

import { AreaProps } from "../types";

import { BandWidthSeries } from "./type";
import { bandwidthColorBand } from "./utils";

const Indicator = (props: AreaProps<BandWidthSeries>) => {
  const { data, yScale, xScale, adaptedCursor } = props;

  const indicatorRef = useRef<SVGGElement>(null);
  const snapDate = adaptedCursor?.snapDate;

  useEffect(() => {
    if (!data || data.length === 0) return;

    const indicatorGroup = d3.select(indicatorRef.current);
    const color = bandwidthColorBand[data?.key || ""];

    // Add circle indicators for EVERY data point
    indicatorGroup
      .selectAll("circle")
      .data(data)
      .join("circle")
      .attr("cx", d => xScale(d.data.date))
      .attr("cy", d => yScale(d[1] || 0))
      .attr("r", 3)
      .attr("fill", color)
      .attr("stroke", "var(--snow)")
      .attr("stroke-width", 1)
      .attr("opacity", ({ data }) =>
        data.date.getTime() === snapDate?.getTime() ? 1 : 0
      );
  }, [data, xScale, yScale, snapDate]);

  return <g ref={indicatorRef} />;
};

export default Indicator;
